import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sort',
  standalone: true,
  templateUrl: './icon-sort.component.html',
  styleUrl: './icon-sort.component.css'
})
export class IconSortComponent {
  @Input() sortAscending: boolean = true;
}
